import { createImage } from './create';

export async function loadImage(url: string): Promise<void> {
	// eslint-disable-next-line promise/avoid-new
	return new Promise((resolve, reject) => {
		const image = createImage();
		image.onload = () => {
			resolve();
		};
		image.onerror = () => {
			// eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
			reject();
		};
		image.src = url;
	});
}
